import TypographyParagraph from '../typography/TypographyParagraph'

const Revoke = ({ metadata }: { metadata: any }) => {
	return (
		<div className="flex flex-col">
			<TypographyParagraph
				size="medium"
				additionalClasses="mb-4 text-textPrimaryLight dark:text-textPrimaryDark"
			>
				{metadata.properties.description}
			</TypographyParagraph>
		</div>
	)
}

export default Revoke
